import $ from "jquery"
import "jquery-match-height";
import {Fancybox} from "@fancyapps/ui/src/Fancybox/Fancybox.js";
import "magnific-popup";

$('.js-match-height-investment').matchHeight();
$('.js-match-height-about-box').matchHeight();

Fancybox.bind("[data-fancybox]", {
    Thumbs: {
        autoStart: false,
    },
    Toolbar: {
        display: [
            "close",
        ],
    },
});

// Location distance switcher
$('.js-location-meta').each(function () {
    $(this).on('click', function () {
        var jsLocationMetaData = $(this).data('meta');

        $(this).closest('.location__meta').find('.js-location-distance').text(jsLocationMetaData);
        $(this).closest('.location__meta').find('.js-location-meta').removeClass('active');
        $(this).addClass('active');
    });
});

$('.clear-data').on('click', function (e) {
    $('.browser__form select option').removeAttr("selected");
    $('.browser__form input').attr('value', '');
    $('.search').trigger('click');
    e.preventDefault();
})
// contact popup
function init_popup() {
    document.querySelectorAll(".popup-container").forEach((popup)=>{
        let popupType = popup.dataset.type;
        let selector = "popup" + popupType;

        if (window.localStorage.getItem(selector)) {
            return;
        }

        window.localStorage.setItem(selector, '1');
        window.popup = $.magnificPopup.open({
            items: {
                type: 'inline',
                src: $(popup),
            }
        });
    })
}

$(function () {
    setTimeout(function () {
        init_popup();
    }, 5000);
});